// extracted by mini-css-extract-plugin
module.exports = {"switch":"style_switch__3e0Bm"};